import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type OlkyPassSlice = {
  level: number;
};
export const OLKYPASS_INITIAL = {
  level: -1
} satisfies OlkyPassSlice as OlkyPassSlice;

export const olkypassSlice = createSlice({
  name: "olkypass",
  initialState: OLKYPASS_INITIAL,

  reducers: {
    setOlkypassLevel: (state, action: PayloadAction<number>) => {
      state.level = action.payload;
    },
    resetOlkypass: () => OLKYPASS_INITIAL
  }
});

export const { resetOlkypass, setOlkypassLevel } = olkypassSlice.actions;
